<template>
  <article class="pagination-wrapper">
    <BaseButton
      v-if="!hideLoadMore"
      color="primary"
      size="l"
      :text="t('timetable.load-more')"
      @click="emit('load-more-click')"
    />
    <BaseButton
      v-if="!hideLink"
      :tag="NuxtLink"
      :to="
        useLocalePath()({
          name: 'slug',
          params: { slug: t('timetable.slug') }
        })
      "
      color="outline-black"
      size="l"
      :text="t('timetable.show-calendar-with-all-courses')"
    />
  </article>
</template>

<script lang="ts" setup>
import { NuxtLink } from '#components'

defineProps<{ hideLoadMore: boolean; hideLink: boolean }>()
const emit = defineEmits<{ (event: 'load-more-click'): void }>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  @include flex-col;
  gap: rem(32px);
  margin-top: rem(72px);

  @include media-up(md) {
    flex-direction: row;
  }
}
</style>
